//Generated File 
export const DOWNLOAD = `DOWNLOAD`;
export const PREVIEW = `PREVIEW`;
export const PRINT = `PRINT`;
export const THUMBNAIL = `THUMBNAIL`;
